import { render, staticRenderFns } from "./MsgElementKeywords.vue?vue&type=template&id=be2ce3fc&scoped=true"
import script from "./MsgElementKeywords.vue?vue&type=script&lang=js"
export * from "./MsgElementKeywords.vue?vue&type=script&lang=js"
import style0 from "./MsgElementKeywords.vue?vue&type=style&index=0&id=be2ce3fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2ce3fc",
  null
  
)

export default component.exports